import { __decorate } from "tslib";
/**
 * 全部审批驳回
 * params:colums 表头数据
 * */
import React, { Component } from 'react';
import { Table } from 'antd';
import { connect } from '@souche-f2e/muji';
import { TableContainer, showInfo } from '@/components';
import { dispatch } from '@@/store';
import styles from '../_style/index.less';
import Mapping from '@/shared/mapping';
import { dealListValueShow } from '@/shared/functions';
const mapStateToProps = (rootState) => ({
    approve: rootState.approve,
});
// @ts-ignore
let ApproveResultFail = class ApproveResultFail extends Component {
    constructor(props) {
        super(props);
        this.checkFailReason = (data) => {
            showInfo('userDefine', {
                title: '驳回原因',
                content: [{
                        key: '驳回原因',
                        value: data.comment,
                    }],
            });
        };
        // desc 表格跳页
        this.tableUpdate = (page, pageSize) => {
            dispatch.approve.updateTable({ page });
        };
        this.state = {
            AllColums: [
                {
                    title: '操作人',
                    dataIndex: 'editedBy',
                    align: 'left',
                },
            ],
            colums: [
                {
                    title: '驳回时间',
                    dataIndex: 'modifyTime',
                    align: 'left',
                },
            ],
            opera: [
                {
                    title: '驳回原因',
                    dataIndex: 'comment',
                    align: 'left',
                    fixed: 'right',
                    width: 180,
                    render: (text, record, index) => (<div className={styles.table_row_operate}>
              <a onClick={(event) => {
                        this.checkFailReason(record);
                    }}>
                查看
              </a>
            </div>),
                },
            ],
            index: [
                {
                    title: '序号',
                    dataIndex: 'index',
                    align: 'left',
                    fixed: 'left',
                    width: 100,
                    render: (text, record, index) => {
                        const pageIndex = this.props.approve.pageIndexFail - 1;
                        return (<span>{(pageIndex * 20) + index + 1}</span>);
                    },
                },
            ],
        };
    }
    componentWillMount() {
        setTimeout(() => {
            const { activeTab } = this.props.approve;
            !activeTab && dispatch.approve.updateTable({ page: 1, acyiveKey: 'Fail' });
        });
    }
    render() {
        const { tableFail, pageIndexFail, tableFailTotal, isMy, pageSizeFail, tableKey, loadingFail, exportParams } = this.props.approve;
        const { tableColums } = this.props;
        const { index, colums, AllColums, opera } = this.state;
        const myColums = isMy ? [] : AllColums;
        const table = [...index, ...tableColums, ...colums, ...myColums, ...opera];
        return (<TableContainer totalNum={tableFailTotal} isTab exportObj={{
            type: 'goods',
            params: exportParams,
            fileName: `${isMy ? '我的' : '全部'}审批驳回`,
            allow: isMy ? Mapping.exportAllow.psgjb_carrejectmine_export.value : Mapping.exportAllow.psgjb_carreject_export.value,
        }}>
        <Table scroll={{ x: '170%' }} loading={loadingFail} rowKey={tableKey} columns={table} dataSource={dealListValueShow({
            gistData: table,
            data: tableFail,
        })} pagination={{
            current: pageIndexFail,
            pageSize: pageSizeFail,
            showQuickJumper: true,
            total: tableFailTotal,
            onChange: this.tableUpdate,
        }}/>
      </TableContainer>);
    }
};
ApproveResultFail = __decorate([
    connect(mapStateToProps)
], ApproveResultFail);
export default ApproveResultFail;
